import { currencyInMoneyResourceFormat } from 'common/filters/addCurrency'
import { IMoneyResource } from 'applications/desktop/package-compare-app/types/package-compare-app.types'

import decimalPlace from 'common/filters/decimalPlace'

export default (value: IMoneyResource, countDecimal: number = 2) => {
  return currencyInMoneyResourceFormat({...value, amount: decimalPlace(value.amount || value.total, countDecimal)})
}